export default __webpack_public_path__ + "static/media/bouleClear.1446c8b0.png";